import React from 'react';
import { Modal, Button, Spin, Icon } from 'antd';
import './ImageEnhanceCompareModal.scss';

const ImageEnhanceCompareModal = ({
  visible,
  phase,
  error,
  originalUrl,
  enhancedPreviewUrl,
  onKeepOriginal,
  onUseEnhanced,
  onClose,
}) => {
  const isLoading = phase === 'loading';
  const isUploading = phase === 'uploading';
  const isCompare = phase === 'compare';

  const footer = isCompare
    ? [
        <Button key="original" onClick={onKeepOriginal}>
          Keep original
        </Button>,
        <Button key="enhanced" type="primary" className="sl-ai-modal-primary" onClick={onUseEnhanced}>
          Use enhanced image
        </Button>,
      ]
    : isUploading
      ? null
      : [
          <Button key="close" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>,
        ];

  return (
    <Modal
      title="Enhance with AI"
      visible={visible}
      onCancel={isLoading || isUploading ? undefined : onClose}
      footer={footer}
      width={720}
      wrapClassName="sl-ai-enhance-modal"
      destroyOnClose
      maskClosable={!isLoading && !isUploading}
      closable={!isLoading && !isUploading}
      style={{ top: 24 }}
      bodyStyle={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', overflowX: 'hidden' }}
    >
      {isLoading && (
        <div className="sl-ai-modal-loading">
          <Spin indicator={<Icon type="loading" style={{ fontSize: 36 }} spin />} />
          <p className="sl-ai-modal-loading-text">Enhancing your image with AI…</p>
          <p className="sl-ai-modal-loading-hint">This usually takes 10–30 seconds depending on load.</p>
        </div>
      )}

      {isUploading && (
        <div className="sl-ai-modal-loading">
          <Spin indicator={<Icon type="loading" style={{ fontSize: 36 }} spin />} />
          <p className="sl-ai-modal-loading-text">Saving your enhanced image…</p>
        </div>
      )}

      {error && !isLoading && !isUploading && (
        <div className="sl-ai-modal-error">
          <Icon type="exclamation-circle" />
          <span>{error}</span>
        </div>
      )}

      {isCompare && originalUrl && enhancedPreviewUrl && (
        <>
          <p className="sl-ai-modal-intro">
            Compare your original and AI-enhanced photo, then choose which one to use in your listing.
          </p>
          <div className="sl-ai-compare-row">
            <div className="sl-ai-compare-card">
              <p className="sl-ai-compare-label">Original</p>
              <div className="sl-ai-compare-img-wrap">
                <img src={originalUrl} alt="Original" className="sl-ai-compare-img" />
              </div>
            </div>
            <div className="sl-ai-compare-card sl-ai-compare-card--enhanced">
              <p className="sl-ai-compare-label">Enhanced</p>
              <div className="sl-ai-compare-img-wrap">
                <img src={enhancedPreviewUrl} alt="Enhanced" className="sl-ai-compare-img" />
              </div>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ImageEnhanceCompareModal;
